import * as React from 'react';
import { Typography } from '@mui/material';
import Fade from '@mui/material/Fade';
import InfoCard from './Card.js';
import Grid from '@mui/material/Grid';
import TitleChange from './titleChanger.js';


function MurmurDetails() {
    return (
        <div>
            <Grid variant='container'>                
                <Grid variant='item'>
                    <Typography variant='body1'><a href='https://www.instagram.com/sarahtakash/' target='_blank' rel="noreferrer" > Sarah Takash - dance </a></Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'><a href='http://www.zachlapidus.com/' target='_blank' rel="noreferrer" > Zach Lapidus - Buchla Synthesizer </a></Typography>
                </Grid>
                <Grid variant='item'>
                    <Typography variant='body1'> Fraser A Campbell - Clarinet / Visuals</Typography>
                </Grid>
            </Grid>
        </div >

    )
};

function Murmur() {

    TitleChange("Murmur");

    return (
        <div className="App-container">
            <Fade in mountOnEnter unmountOnExit timeout={3000}>
                <Typography sx={{ marginTop:{xs: '7rem', md: '5rem'} }} variant="h2" color="gold">Murmur</Typography>
            </Fade>
            <Fade in mountOnEnter unmountOnExit timeout={3000}>
                <Typography variant="h4" color="cornflowerblue">Multimedia project - dance / synth / winds / visuals</Typography>
            </Fade>
            <InfoCard MediaInfo={MurmurDetails}
            cardComp='iframe'
                textURL="https://www.youtube.com/embed/videoseries?si=-OdM2BgiO1vqXpP2&amp;list=PLOWYuRguFrOIOAfmZIfXwv8vz2K9mSViT"
                textTitle="Murmur - Multimedia project - dance / synth / winds / visuals" />
        </div>
    )
};

export default Murmur;